/**
 * External Imports
 */
import styled from 'styled-components';

interface ICSSProps {
  isLoading: boolean;
}

export const SurveyContainer = styled.section<ICSSProps>`
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.isLoading ? 'center' : 'start')};
  height: 100%;
  overflow: scroll;
  fontsize: 0.75rem;
  padding-left: ${props => (props.isLoading ? '0px' : '3em')};
  padding-right: 2em;
  margin: 0.75em 0px;
`;
